import { Link } from "react-router-dom";

const NotFoundPage = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] px-6" data-testid="not-found-page">
    <div className="text-center">
      <h1 className="text-6xl sm:text-7xl font-bold text-[#0A0A0A] mb-4">404</h1>
      <p className="text-lg text-[#4A4A4A] mb-8">This page doesn't exist.</p>
      <Link to="/" className="brutalist-btn-primary inline-block" data-testid="not-found-home-link">
        Back to Home
      </Link>
    </div>
  </div>
);

export default NotFoundPage;
